module.exports = __webpack_public_path__ + "static/australian-vitamins-00-hero-70ee6c33a43fe6045388eabc12db9d24.jpg";